import { memoize } from 'lodash';

/**
 * Determines if the fontColor flags the usage of the reverse focus color.
 *
 * @param {string} fontColor - The font color to check.
 * @returns {boolean} - Returns true if the font color is a reverse focus color, otherwise false.
 */
export const reverseFocusFromColor = memoize(fontColor =>
  Boolean(fontColor && fontColor.toLowerCase().endsWith('reverse'))
);
